import React from 'react';

import { useSelector } from 'react-redux';

import { SELF } from '../../../../shared/constants';
import { useActiveDeviceStream } from '../../../../shared/features/device-manager/hooks';
import { getUserSelector } from '../../../../shared/features/user';
import { getParticipant } from '../../selectors';
import Participant from '../participant';

export const GoloomJoinParticipantContainer: React.FC = ({ children }) => {
    const user = useSelector(getUserSelector);
    const self = useSelector((state) => getParticipant(state, SELF));
    const mediaStream = useActiveDeviceStream('videoinput');

    return (
        <Participant
            id={SELF}
            uid={user?.uid}
            avatarUrl={self.avatarUrl}
            shouldRenderAvatar={self.shouldRenderAvatar}
            isFromOverlay
            videoTrackState={self.videoTrackState}
            videoStream={mediaStream}
        >
            {children}
        </Participant>
    );
};
